<template>
  <div>
    <div v-if="!isLoading" class="box box-default">
      <div class="box-header">
        <div class="flex align-items-center justify-between">
          <h3 class="box-title mb-0">Merchant CC</h3>
          <button class="btn btn-primary" @click="insertMerchantCC()">Add New Merchant CC</button>
        </div>
      </div>
      <div class="box-body no-padding">
        <div class="table-responsive">
          <table class="table table-striped table-condensed">
            <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>UsedID</th>
              <th>Active</th>
              <th>URL String</th>
              <th>BasicOnly</th>
              <th>CreatedOn</th>
              <th>ModifiedOn</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="records.length > 0">
              <tr v-for="(record, index) in records" :key="index">
                <td>{{ record.PrimaryID }}</td>
                <td>
                  <span class="pointer" @click="launchEditMerchantCCModal(record, 'Name')">{{ record.Name }}</span></td>
                <td>
                  <span class="pointer" @click="launchEditMerchantCCModal(record, 'UsedID')">{{ record.UsedID }}</span></td>
                <td>
                  <span @click="launchEditMerchantCCModal(record, 'Active')" v-html="formatStatus(record.Active)"></span>
                </td>
                <td>
                  <div style="min-height:60px;max-width: 400px;" class="textarea pointer" v-html="record.URLString"
                       @click="launchEditMerchantCCModal(record, 'URLString')"></div>
                </td>
                <td>
                  <span class="pointer" @click="launchEditMerchantCCModal(record, 'BasicOnly')"
                        v-html="formatStatus(record.BasicOnly)"></span>
                </td>
                <td>{{ record.CreatedOn }}</td>
                <td>{{ record.ModifiedOn }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8">No record found!</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <merchant-c-c-modal></merchant-c-c-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { START_LOADING, STOP_LOADING } from '../store/keys'
import { formatStatus, saveNotification } from '../lib/utils'
import MerchantCCModal from '../components/modals/MerchantCCModal'

export default {
  name: 'MerchantCC',
  components: { MerchantCCModal },
  data() {
    return {
      records: []
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'jwtToken',
      'currentUser'
    ])
  },
  methods: {
    formatStatus(status) {
      return formatStatus(status === 1 ? 'Yes' : 'No', '60')
    },
    getRecords(isLoader = true) {
      if (isLoader) {
        this.$store.commit(START_LOADING)
      }
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=ListMerchantCC`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        }
      }).then(response => {
        this.$store.commit(STOP_LOADING)
        this.records = response.data.data
      }).catch(error => {
        this.$store.commit(STOP_LOADING)
        this.$toast.fire('', error.data.message, 'error')
        saveNotification(error.data.message)
      })
    },
    insertMerchantCC() {
      const url = `https://app.cointopay.com/v2REAPI?Call=MerchantCCInsert&output=json&MerchantID=${this.currentUser.ID}&APIKey=${this.currentUser.APIKey}`
      this.$http.get(url).then(response => {
        if (response.data.status_code === 200) {
          this.getRecords(false)
          this.$toast.fire('', response.data.message, 'success')
        } else {
          this.$toast.fire('', response.data.message, 'error')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    launchEditMerchantCCModal(record, key) {
      this.$bus.$emit('merchant-cc-modal', {
        title: 'Update Merchant CC',
        record: record,
        key: key,
        confirm: () => {
          this.getRecords(false)
        }
      })
    }
  },
  mounted() {
    this.getRecords()
  }
}
</script>

<style scoped></style>
